import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import AccountingReportLogEntry from "../../models/accounting-reports";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { formatUTCDateTime } from "../../utils/dates";

interface AccountingReportLogDeleteModalProps {
  show: boolean;
  accountingreportlog?: AccountingReportLogEntry;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AccountingReportLogDeleteModal: React.FC<
  AccountingReportLogDeleteModalProps
> = ({ show, accountingreportlog, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const message = accountingreportlog
    ? `Está seguro de que quiere eliminar el reporte contable: ${
        accountingreportlog.obs
      } - ${formatUTCDateTime(new Date(accountingreportlog.createdAt!))}`
    : "";

  const onDeleteClick = async () => {
    if (accountingreportlog !== undefined) {
      setSubmitting(true);
      const accountingLogStatus = await deleteItem<AccountingReportLogEntry>(
        `/accounting_reports/${accountingreportlog.id}/`,
        accountingreportlog
      );

      if (accountingLogStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (accountingLogStatus.detail !== undefined) {
          message = accountingLogStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <h3 className="text-danger">Precaución</h3>
              <h5>Los datos dentro de este reporte no se podrán recuperar.</h5>
              <br />
              <h5>Podrá generar un nuevo reporte.</h5>
              <br />
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AccountingReportLogDeleteModal;
